import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		root: {
			borderRight: "1px solid rgba(0, 0, 0, .02)",
			cursor: "pointer",
		},
		asc: {
			boxShadow: "inset 0 -3px 0 0 rgba(0, 0, 0, .6)",
		},
		desc: {
			boxShadow: "inset 0 3px 0 0 rgba(0, 0, 0, .6)",
		},
	} satisfies Record<string, CSSObject>);
};
